import LexIAPromptForm from "./components/Form";

export default function Root(props) {
  return (
    <>
      {/* <section>{props.name} is mounted!</section> */}
      <LexIAPromptForm />
    </>
  );
}
